import React from 'react';

import ChildrenPropType from 'lib/CustomPropTypes/children';
import Breakpoints from 'lib/Breakpoints';

const defaultBreakpointState = {
  isS: false,
  isM: false,
  isL: false,
  isXL: true,
  isXXL: false,
  isSorM: false,
  isLorXL: true,
};

export const BreakpointContext = React.createContext(defaultBreakpointState);

export const BreakpointContextProvider = ({ children }) => {
  const [breakpointState, setBreakpointState] = React.useState(defaultBreakpointState);

  const breakpointChangeListener = React.useCallback(() => {
    setBreakpointState({
      isS: Breakpoints.isS(),
      isM: Breakpoints.isM(),
      isL: Breakpoints.isL(),
      isXL: Breakpoints.isXL(),
      isXXL: Breakpoints.isXXL(),
      isSorM: Breakpoints.isSorM(),
      isLorXL: Breakpoints.isLorXL(),
    });
  }, [Breakpoints]);

  React.useEffect(() => {
    Breakpoints.listenToAll(breakpointChangeListener);

    return () => {
      Breakpoints.removeFromAll(breakpointChangeListener);
    };
  }, [Breakpoints, breakpointChangeListener]);

  // set the breakpoint state once on initial "mount", no deps needed
  React.useEffect(() => {
    setBreakpointState({
      isS: Breakpoints.isS(),
      isM: Breakpoints.isM(),
      isL: Breakpoints.isL(),
      isXL: Breakpoints.isXL(),
      isXXL: Breakpoints.isXXL(),
      isSorM: Breakpoints.isSorM(),
      isLorXL: Breakpoints.isLorXL(),
    });
  }, []);

  return (
    <BreakpointContext.Provider value={breakpointState}>
      {children}
    </BreakpointContext.Provider>
  );
};

BreakpointContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};
